<template>
<div class="chapter">
<div class="inner_page">
<p class="fm"><i>I’d like to dedicate this book to Ron Goulart</i>.</p>
<p class="fm1"><i>Mining the words out of a rich vein of plot</i>—</p>
<p class="fm1"><i>a miner, but no minor, his face blackened</i></p>
<p class="fm1"><i>with printer’s ink, his fingers blue with</i></p>
<p class="fm1"><i>bruises from the keyboard</i>—<i>he toils in</i></p>
<p class="fm1"><i>unrecognized effort. Hail to you, Ronald, a</i></p>
<p class="fm1"><i>writer of minor physique but of major talent</i>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?588394dc